<template>
  <div class="header-box">
    <div class="header-nav flex items-center justify-between px-20">
      <div class="flex items-center h-full">
        <img src="@/assets/home/nav-logoNew.png" class="website-logo mr-20" />
        <a-dropdown arrow placement="bottomLeft" trigger="click" overlayClassName="city-dropdown-box">
          <div class="select-city flex items-center mr-52">
            <img src="@/assets/home/icon-location.png" class="icon-location mr-5" />
            <span class="text-base text-[#00CCA0] mr-3">{{ currentCity.district }}</span>
            <div class="btn-change text-base text-[#999999]">[切换]</div>
          </div>
          <template #overlay>
            <CitySelect @changeCity="changeCity"></CitySelect>
          </template>
        </a-dropdown>
        <div class="nav-list flex items-center">
          <a-menu v-model:selectedKeys="activeNavKey" mode="horizontal" :items="navsList" @click="clickNavItem" />
        </div>
      </div>
      <div>
        <div v-if="userInfo && userInfo.userId" class="have-login flex items-center">
          <div v-if="userInfo.businessType != 'COMPANY'" class="my-platform px-13 mr-24" @click="openManagerPage">我的工作台</div>
          <!-- <a-badge :count="5" :offset="[0, 3]"> -->
          <div class="user-info flex items-center" :style="{ 'padding-right': userInfo.isAuth ? '17px' : '2px' }">
            <a-dropdown arrow>
              <div class="flex items-center" @click="goPersonalPage">
                <a-avatar v-if="userInfo.absAvatar" :src="userInfo.absAvatar" :size="26" />
                <img v-else src="@/assets/personal/upload-default.png" style="width: 26px; height: 26px" />
                <div class="user-name mx-7 truncate">{{ userInfo.userRealName || userInfo.userName }}</div>
              </div>
              <template #overlay>
                <a-menu>
                  <a-menu-item @click="signOut">退出登录</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
            <div v-if="userInfo.orgState == 'FORBIDDEN' && !userInfo.auditState" class="btn-auth ml-6" @click.stop="goPersonalPage">去认证</div>
          </div>
          <!-- </a-badge> -->
        </div>
        <div v-else class="no-login px-12 py-6" @click="btnLogin">注册<span class="sm-line mx-10">|</span>登录</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CitySelect from './citySelect'
import axios from 'axios'
import { reactive, ref, computed, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { DownOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import api from '@/net/api'
const store = useStore()
const router = useRouter()
const route = useRoute()
const userInfo = computed(() => store.state.user?.userInfo || {})
const Token = computed(() => store.state.token?.token || '')
const currentCity = computed(() => store.state.city.currentCity)
const navsList = computed(() => store.state.user?.navsList || [])

const activeNavKey = ref([''])
// const navsList = ref(
//   // [
//   //   { title: '首页', label: '首页', router: '/main/home' },
//   //   { title: '采购商城', label: '采购商城', router: '/main/buyMall' }
//   // ].map(v => ({ ...v, key: v.router }))
//   []
// )

// 点击导航
function clickNavItem({ item, key, keyPath }) {
  activeNavKey.value = keyPath
  router.push(item.router)
}

watch(
  () => route.path,
  newVal => {
    renderActiveNav(newVal)
  },
  { immediate: true }
)
watch(
  () => store.state.user.userInfo,
  // && _userInfo?.orgState==='ON'
  // ||_userInfo.businessType==='BUYER'&&_userInfo.businessLevel==='ADMIN' && _userInfo.auditState==='PASSED'
  //     ||_userInfo.businessType==='BUYER'&&_userInfo.businessLevel==='RESTAURANT'
  //     ||_userInfo.businessType==='BUYER'&&_userInfo.businessLevel==='WAREHOUSE'
  //     ||_userInfo.businessType==='BUYER'&&_userInfo.businessLevel==='STORE'
  //是学校身份也放开采购商城
  //   _userInfo => {
  //     if(_userInfo?.isCollege ){
  //     let arr = [
  //       { title: '首页', label: '首页', router: '/main/home' },
  //       { title: '采购商城', label: '采购商城', router: '/main/buyMallNew' }
  //     ].map(v => ({ ...v, key: v.router }))
  //     navsList.value = [...arr]
  //   }
  // },
  { immediate: true }
)
// 获取当前激活的路由
function renderActiveNav(path) {
  let pathList = path.split('/')
  let mainIndex = pathList.findIndex(v => v == 'main')
  let keyName = pathList
    .slice(mainIndex, mainIndex + 2) //slice不包含下标为end的数值[)
    .map(v => `/${v}`)
    .join('')
  activeNavKey.value = [keyName]
}

// 登录
function btnLogin() {
  router.push('/login')
}

function changeCity(item) {
  store.commit('SAVE_currentCity', item)
}

// 跳转个人中心
function goPersonalPage() {
  router.push('/main/personalCenter/userInfo')
}

//退出
function signOut() {
  api.get_sysuser_logout().then(res => {
    store.commit('CLEAR_token')
    store.dispatch('clear_productsCart')
    store.dispatch('clear_userInfo')
    store.dispatch('clear_navsList')
    let promise = window.tim.logout();
    promise
      .then(function (imResponse) {
        console.log('@@@@@@@@@@@@@tim我退出来了',imResponse.data);
      })
      .catch(function (imError) {
        console.warn("@@@@@@@@@@@@@@logout error:", imError);
      });
    router.replace('/login')
  })
}

// 跳转管理后台
function openManagerPage() {
  let url = ''
  switch (process.env.NODE_ENV) {
    case 'development':
      url = 'https://test.rongdaufun.com/'
      break
    case 'production':
      url = 'https://www.rongdajicai.com/'
      if (location.host == 'test.rongdaufun.com') {
        url = 'https://test.rongdaufun.com/'
      }
      break
    default:
      break
  }
  // window.open(url)
  // 创建一个iframe
  const iframe = document.createElement('iframe')
  iframe.style.height = '0'
  iframe.style.border = 'none'
  // 先跳转到 switch-region.html 中转页，将 token 等信息带到新域名
  iframe.src = url+`spa/switch-region.html?Token=`+Token.value

  document.body.appendChild(iframe)

  // iframe加载，表示token已经写入到新域名中
  // 跳转到 ng 站点
  iframe.onload = () => {
    let timer = setTimeout(() => {
      // window.location.href = 'https://www.rongdajicai.com/sc-manager/'
      window.open('https://www.rongdajicai.com/sc-manager/')
      clearTimeout(timer)
    }, 1000)
  }

}

// const props = defineProps(['active'])
// const emits = defineEmits(['refresh'])
// const showSelectCity = ref(false)
// const currentCity = ref({
//   city: '全国',
//   districtCode: 0
// })

// function initMap() {
//   axios.get('https://restapi.amap.com/v3/ip?key=6f92bb85c9e134020827c10bb54274c5').then(res => {
//     if (res.status == 200) {
//       let data = {
//         city: res.data.city,
//         districtCode: res.data.adcode
//       }
//       currentCity.value = data
//       localStorage.setItem('currentCity', JSON.stringify(data))
//       emits('refresh', currentCity.value)
//     }
//   })
// }
// let storage = localStorage.getItem('currentCity')
// if (storage && storage != '{}') {
//   currentCity.value = JSON.parse(storage)
//   emits('refresh', currentCity.value)
// } else {
//   initMap()
// }

// // 切换城市
// function changeCity() {
//   showSelectCity.value = !showSelectCity.value
// }
// // 确认切换
// function confirmCity(e) {
//   let data = {
//     districtCode: e.value + '00',
//     city: e.label
//   }
//   changeCity()
//   currentCity.value = data
//   localStorage.setItem('currentCity', JSON.stringify(data))
//   emits('refresh', currentCity.value)
// }
</script>

<style scoped lang="scss">
.header-box {
  width: 100%;
  height: 50px;
  background: #282828;
}

.header-nav {
  max-width: 1400px;
  min-width: 1200px;
  height: 100%;
  margin: 0 auto;
  background: #282828;

  .website-logo {
    width: 140px;
    height: 39px;
  }

  .select-city {
    cursor: pointer;

    .icon-location {
      width: 20px;
      height: 20px;
      font-family: MicrosoftYaHei;
    }
  }

  .nav-list {
    height: 100%;

    :deep(.ant-menu-light) {
      background: transparent;

      &.ant-menu-horizontal {
        line-height: 50px;
      }

      .ant-menu-item {
        height: 100%;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        color: #dbdbdb;
        padding: 0 26px;
        cursor: pointer;
        &::after {
          border: unset;
        }
        &:hover {
          &::after {
            border: unset;
          }
        }
      }
      .ant-menu-item-selected {
        background: #303030;
        font-weight: bold;
        color: #00cca0;
        &::after {
          border: unset;
        }
      }
    }
  }

  .no-login {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #00cca0;
    border: 1px solid #00cca0;
    border-radius: 30px;
    cursor: pointer;
  }

  .have-login {
    .my-platform {
      height: 30px;
      line-height: 30px;
      background: #424242;
      border-radius: 15px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      cursor: pointer;
    }

    :deep(.ant-badge-count) {
      min-width: 15px;
      height: 15px;
      line-height: 15px;
      .ant-scroll-number-only {
        height: 15px;
        line-height: 15px;
      }
      .ant-scroll-number-only-unit {
        height: 15px;
        line-height: 15px;
      }
    }

    .user-info {
      border-radius: 18px;
      border: 1px solid #00cca0;
      padding: 1px 2px;
      cursor: pointer;

      .user-name {
        max-width: 100px;
        font-size: 14px;
        line-height: 20px;
        font-family: MicrosoftYaHei;
        color: #00cca0;
      }

      .btn-auth {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        background: #4f4f4f;
        border-radius: 18px;
        padding: 5px 12px;
      }
    }
  }
}
</style>
